import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { useBuscarInteressesProprietarios } from "./hooks/useBuscarInteressesProprietarios";
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import {
  Col,
  Flex,
  Row,
  Button,
  MenuProps,
  Skeleton,
  Table,
  Typography,
} from "antd";
import type { TableProps } from "antd/es/table";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import { Columns } from "./components/Columns";
import { Container } from "./styles";

interface LocationState {
  userId?: number;
  nomeProp?: string;
}
export default function ViewGerenciarInteressesProprietarios() {
  const location = useLocation();
  const state = location.state as LocationState;
  const userId = state?.userId;
  const nomeProp = state?.nomeProp;

  // Traz o estilo Title da biblioteca
  const { Title } = Typography;
  const isMobile = useMediaQuery("(max-width:600px)");

  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO
  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading, isValid } = usePermissao("OPE");

  // Controle de Paginação
  const [currentPage, setCurrentPage] = useState(1);

  const { interesses, isLoading, buscar } = useBuscarInteressesProprietarios(
    userId!
  );
  const [interesseId, setInteresseId] = useState<number>();

  // Inicializando o filtro
  const [filteredInfo, setFilteredInfo] = useState<{
    dataIni?: string[] | null;
    dataFim?: string[] | null;
    situacao?: string[] | null;
    status?: string[] | null;
  }>({
    dataIni: null,
    dataFim: null,
    situacao: null,
    status: null,
  });
  const [semFiltros, setSemFiltros] = useState(true);

  useEffect(() => {
    const filtros = localStorage.getItem("filtrosInteresses");
    const pagina = localStorage.getItem("pageInteresses");

    if (filtros) {
      const novoFiltro = JSON.parse(filtros);
      setFilteredInfo({
        dataIni: novoFiltro.dataIni ?? null,
        dataFim: novoFiltro.dataFim ?? null,
        situacao: novoFiltro.situacao ?? null,
        status: novoFiltro.status ?? null,
      });

      setSemFiltros(false);
    }

    if (pagina) {
      setCurrentPage(Number(pagina));
    }
  }, []);

  const onChange: TableProps<any>["onChange"] = (pagination, filters) => {
    setFilteredInfo({
      dataIni: filters.dataIni as string[] | null,
      dataFim: filters.dataFim as string[] | null,
      situacao: filters.situacao as string[] | null,
      status: filters.status as string[] | null,
    });

    const hasFilters = Boolean(
      filters.dataIni || filters.dataFim || filters.situacao || filters.status
    );
    setSemFiltros(!hasFilters);

    if (pagination.current) {
      localStorage.setItem("pageInteresses", pagination.current.toString());
    }

    localStorage.setItem("filtrosInteresses", JSON.stringify(filters));
  };

  const removerFiltros = () => {
    localStorage.removeItem("filtrosInteresses");
    localStorage.removeItem("pageInteresses");

    setFilteredInfo({
      dataIni: null,
      dataFim: null,
      situacao: null,
      status: null,
    });
    setSemFiltros(true);
    setCurrentPage(1);
  };

  const handleFilter = () => {
    removerFiltros();
  };

  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      // Excluir
      case "1":
        alert("Em desenvolvimento...");
        break;
      // Excluir
      case "2":
        alert("Em desenvolvimento...");
        break;
    }
  };

  const columns = Columns(onClick, setInteresseId, {
    dataIni: filteredInfo.dataIni,
    dataFim: filteredInfo.dataFim,
    situacao: filteredInfo.situacao,
    status: filteredInfo.status,
  });

  return (
    <>
      {(isLoading && isTokenLoading) || !isValid ? (
        <Skeleton active />
      ) : (
        <>
          <Container>
            <Row>
              <Col span={5}>
                <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                  <a href={`/gerenciarusuarios`}>
                    <ArrowBackIcon color="primary" />
                  </a>
                </Flex>
              </Col>
              <Col span={12}>
                <Flex align="center" justify="center">
                  <HomeIcon color="primary" fontSize="large" />
                  <Title
                    style={{
                      marginLeft: 10,
                      marginTop: 10,
                      fontSize: isMobile ? "1rem" : "2rem",
                      color: "rgb(0, 54, 68)",
                    }}
                    level={3}
                  >
                    Interesses de {nomeProp}
                  </Title>
                </Flex>
              </Col>
            </Row>

            <Row>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  height: "auto",
                  width: "90%",
                  gap: "20px",
                }}
              >
                <div style={{ display: "flex", gap: "20px" }}>
                  {/* <Button
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "auto",
                    }}
                    onClick={handleModalAdicionar}
                    type="primary"
                  >
                    + Indicação Parceiro
                  </Button> */}

                  {semFiltros ? (
                    <Button onClick={handleFilter} type="primary" disabled>
                      <FilterAltIcon />
                    </Button>
                  ) : (
                    <Button onClick={handleFilter} type="primary">
                      <FilterAltOffIcon />
                    </Button>
                  )}
                </div>
              </div>
              <Col span={isMobile ? 5 : 1}></Col>

              <Col
                span={22}
                style={{
                  marginTop: isMobile ? 15 : 15,
                  marginBottom: isMobile ? 30 : 50,
                }}
              >
                <Flex
                  style={{
                    width: isMobile ? "auto" : "100%",
                    overflow: "auto",
                    marginLeft: 30,
                  }}
                >
                  <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={interesses}
                    onChange={onChange}
                    bordered
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: isMobile ? "auto" : "100%",
                      maxWidth: isMobile ? "none" : "100%",
                    }}
                    pagination={{ defaultCurrent: currentPage }}
                  />
                </Flex>
              </Col>

              <Col span={1}></Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
}
